import { observer } from 'mobx-react-lite';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';

import { Icon, IconClose, IconMagnifier } from '@flixbus/honeycomb-icons-react';
import { Button, Input } from '@flixbus/honeycomb-react';

import { rideFilterStore } from 'pages/RideListPage/components/RideFilters/RideFilterStore';
import { rideListStore } from 'pages/RideListPage/RideListStore';

import { RIDE_ID_FILTER_TEXT, RIDE_ID_LENGTH } from './texts';

import styles from './styles.module.css';

/**
 * @typedef {object} RideIdFormValues
 * @property {string} rideId
 */

const RideIdForm = observer(() => {
	const {
		control,
		handleSubmit,
		watch,
		formState: { isValid },
		reset,
	} = useForm({
		mode: 'onChange',
		defaultValues: {
			rideId: '',
		},
	});

	const watchedValues = watch();

	const handleReset = () => {
		reset();
		rideFilterStore.setRideId('');
		// TODO: CLARIFY DEADHEAD SEARCH
		// rideFilterStore.setDeadheadId('');
	};

	const onSubmit = (data) => {
		// TODO: CLARIFY DEADHEAD SEARCH
		// rideListStore.isDeadheadsTabActive
		// 	? rideFilterStore.setDeadheadId(data.rideId)
		// 	:
		rideFilterStore.setRideId(data.rideId);
	};

	return (
		<form className={styles.row} onSubmit={handleSubmit(onSubmit)}>
			<Controller
				name="rideId"
				control={control}
				disabled={rideListStore.isDeadheadsTabActive}
				rules={{
					required: true,
					maxLength: RIDE_ID_LENGTH,
					minLength: RIDE_ID_LENGTH,
				}}
				render={({ field, fieldState }) => {
					const { isDirty, invalid } = fieldState;

					const inputProps = {
						ref: null,
						id: 'rideId',
						label: RIDE_ID_FILTER_TEXT.label,
						placeholder: RIDE_ID_FILTER_TEXT.placeholder,
					};

					if (isDirty) {
						inputProps.valid = !invalid;
					}

					if (watchedValues?.rideId !== '') {
						inputProps.iconRight = (
							<Button type="button" onClick={() => handleReset()}>
								<Icon id="alignIcon" InlineIcon={IconClose} />
							</Button>
						);
					}

					return <Input extraClasses={styles.input} {...field} {...inputProps} />;
				}}
			/>
			<Button display="square" type="submit" disabled={!isValid}>
				<Icon InlineIcon={IconMagnifier} />
			</Button>
		</form>
	);
});

export default RideIdForm;
